import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import VertForm from "../example/demo/forms/vertForm";
import TransferTable from "../example/demo/tables/transferTable";

class Demo extends PureComponent {
  constructor(props) {
    super();
    this.init();
    this.props = props;
  }

  static contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  }

  init() {
    this.title = "Form示例";
    this.subTitle = "纵向示例表单";
  }

  render() {
    return (
      <div>
        <VertForm tableKey="001" layout={0}></VertForm>
        <TransferTable tableKey="001" addTab={this.props.addTab}></TransferTable>
      </div>);
  }
}

export default Demo;

Demo.propTypes = {
  addTab: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/AntD/pages/cloneTable/demo.js